const collections = {
    PARENT_TYPE : "PARENT_TYPE",
    IDENTIFICATION_TYPE : "IDENTIFICATION_TYPE",
    SEX : "SEX",
    JOB_TYPE : "JOB_TYPE",
    PAYMENT_TYPE: "PAYMENT_TYPE",
    PAYMENT_FRECUENCY: "PAYMENT_FRECUENCY",
    PARENT_STATUS: "PARENT_STATUS",
    DISCOUNT_TYPE:"DISCOUNT_TYPE"
}

const notification = {
    RECIBO : "RECIBO"
}

const userTypes = {
    ADMIN : 1,
    WORKER: 2,
    COODINATOR:4,
    TEACHER:5,
    STUDENT:6,
    PARENTS:7
}

const documentTypes = {
    INCIDENCIA_EVIDENCE: 1,
    TEACHER_SIGNATURE: 2,
    PAYMENT_EVIDENCE: 3,
    AGENDA_FILES: 4,
    CLASSROOM_RESOURCE_FILE: 5,
    CLASSROOM_BANNER: 6,
    TASK_SUBMISSION_FILE: 7,
    FORUM_POST_ATTACHMENT: 8,
    EXAM_ANSWER_FILE: 9,
}

// Espejo de src/utils/types/classroom.types.ts (backend) — los valores
// numéricos deben coincidir exactamente con DB/seed_catalogs.sql.
const classroomResourceTypes = {
    CONTENT: 1,
    FILE: 2,
    VIDEO: 3,
    FORUM: 4,
    TASK: 5,
    EXAM: 6,
    LINK: 7,
}

const classroomTaskTypes = {
    TAREA: 1,
    ACTIVIDAD: 2,
    TALLER: 3,
}

const classroomSubmissionStatus = {
    PENDIENTE: 1,
    ENTREGADO: 2,
    ENTREGADO_TARDE: 3,
    CALIFICADO: 4,
    DEVUELTO: 5,
}

const classroomQuestionTypes = {
    VERDADERO_FALSO: 1,
    OPCION_MULTIPLE: 2,
    OPCION_UNICA: 3,
    SUBIR_ARCHIVO: 4,
    PREGUNTA_ABIERTA: 5,
}

const classroomExamGradingMode = {
    EQUAL: 1,
    WEIGHTED: 2,
}

const classroomAttemptStatus = {
    EN_CURSO: 1,
    ENTREGADO: 2,
    EXPIRADO: 3,
    CALIFICADO: 4,
}

const classroomVideoProvider = {
    YOUTUBE: 1,
    VIMEO: 2,
    OTRO: 3,
}

const reportTypes = {
    ASISTENCIA: 1,
    ACTA: 2,
    BOLETIN: 3,
    ACTAFINALPERIODO: 4,
}

const evaluationTypes = {
    DIMENSION_VALORATIVA: 1,
    ESCALA_VALORATIVA: 2,
    PLANILLA_PREVENTIVA: 3,
}

export default {
    collections,
    notification,
    userTypes,
    documentTypes,
    reportTypes,
    evaluationTypes,
    classroomResourceTypes,
    classroomTaskTypes,
    classroomSubmissionStatus,
    classroomQuestionTypes,
    classroomExamGradingMode,
    classroomAttemptStatus,
    classroomVideoProvider
};